/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class WhitespaceValidator {
  static createValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => ((control.value || '').trim() !== '' ? null : { whitespace: true });
  }
}
